<template>
    <div>
        <Artifact v-if="post.operation === 'create'" :post="post" />
        <LogDetails v-if="post.operation === 'create_kr_checkin'" :details="post.details" />
    </div>
</template>

<script>
import { Artifact, LogDetails } from './components'

export default {
    name: 'Create',
    components: { Artifact, LogDetails },
    props: {
        post: {
            type: Object,
            required: true,
        },
    },
}
</script>

<style scoped></style>
